const routes = (module.exports = require('next-routes')());

routes.add('about', '/about', 'about');
routes.add('add', '/new-insight', 'add');
routes.add('request', '/request', 'request');
routes.add('author', '/user-:slug', 'author');
routes.add('entry', '/insight-:slug', 'entry');
routes.add('faq', '/faq', 'faq');
routes.add('home', '/', 'index');
routes.add('login', '/login', 'login');
routes.add('registration', '/registration', 'registration');
routes.add('poker', '/poker', 'poker');



// WEBPACK FOOTER //
// routes.js